var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06367 9.74993C6.56637 9.2535 6.26367 8.5789 6.26367 7.82215C6.26367 6.30604 7.48486 5.08398 9.0001 5.08398C9.74994 5.08398 10.4401 5.38755 10.9288 5.88398",
    stroke: "#A4A7B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6859 8.30664C11.4852 9.42232 10.6065 10.3027 9.4917 10.5051",
    stroke: "#A4A7B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3773 12.436C3.00476 11.3584 1.84238 9.78435 1 7.82197C1.85103 5.85094 3.02119 4.26824 4.40238 3.18197C5.77492 2.0957 7.35849 1.50586 9 1.50586C10.651 1.50586 12.2337 2.10435 13.6149 3.1984",
    stroke: "#A4A7B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4414 5.09961C16.0364 5.8901 16.5597 6.80253 16.9999 7.82047C15.2987 11.7617 12.2924 14.1357 8.9999 14.1357C8.25352 14.1357 7.51752 14.0146 6.81006 13.7785",
    stroke: "#A4A7B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8216 1L2.1792 14.6424",
    stroke: "#A4A7B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.1610fa90ffdf082bde1e1f9d489854aa.svg";
export { ForwardRef as ReactComponent };